import React from "react";

const escapeRegExp = (text) => text.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

export const getConceptoDestajo = (destajo) =>
  Array.isArray(destajo?.conceptos) && destajo.conceptos.length > 0
    ? destajo.conceptos[0]
    : null;

export const getClaveDestajo = (destajo) => {
  const concepto = getConceptoDestajo(destajo);
  return concepto && concepto.clave ? String(concepto.clave) : null;
};

// Destajo name without a "(clave)" that may come in the stored name, since the
// clave is shown separately as "[clave]".
export const getNombreDestajo = (destajo) =>
  quitarClaveNombre(destajo?.nombre, getClaveDestajo(destajo));

// Name without a "(clave)" inside it, for names that come with the clave apart.
export const quitarClaveNombre = (value, clave) => {
  const nombre = value ? String(value) : "";
  if (!clave) return nombre;
  return nombre
    .replace(new RegExp(`\\(\\s*${escapeRegExp(clave)}\\s*\\)`, "g"), "")
    .replace(/\s{2,}/g, " ")
    .trim();
};

export const renderNombreDestajo = (destajo) => {
  const clave = getClaveDestajo(destajo);
  return (
    <>
      {clave && <span>[{clave}] </span>}
      {getNombreDestajo(destajo)}
    </>
  );
};
